import { render } from "./WuCaiGouFuKuan.vue?vue&type=template&id=287a9376"
import script from "./WuCaiGouFuKuan.vue?vue&type=script&lang=js"
export * from "./WuCaiGouFuKuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__